// Forked from ../ResultsDropdown/StyledComponents.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import styled from 'styled-components';
import { Chip, token } from '@bynder/design-system';
import { useNavigableItem } from '../KeyboardNavigation';

export const StyledImgWrapper = styled.div`
	width: 40px;
	min-width: 40px;
	height: 40px;
	min-height: 40px;
	border-radius: 5px;
	border: 1px solid #d9dee1;
	background: rgba(0, 34, 51, 0.05);
	display: flex;

	& > img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	& > svg {
		width: 24px;
		height: 24px;
		display: block;
		margin: auto;
	}
`;

export const StyledDivider = styled.hr`
	width: 100%;
	height: 1px;
	margin: ${token.spacing3} 0;
	border: none;
	background-color: ${token.gray100a};
`;

export const StyledHeadingWrapper = styled.div<{ $isActive?: boolean }>`
	width: 100%;
	position: relative;
	z-index: 1;
	background-color: ${({ $isActive }) => ($isActive ? token.gray25 : token.white)};
`;

export const StyledHeadingInsideButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	font-weight: 500;
`;

export function NavigableChip({
	children,
	onSelect,
}: {
	children: React.ReactNode;
	onSelect: () => void;
}) {
	const { isActive, itemRef, select } = useNavigableItem<HTMLButtonElement>(onSelect);

	return (
		<StyledNavigableChipWrapper $isActive={isActive}>
			<Chip ref={itemRef} onClick={select} size="s">
				{children}
			</Chip>
		</StyledNavigableChipWrapper>
	);
}

const StyledNavigableChipWrapper = styled.span<{ $isActive: boolean }>`
	display: inline-flex;

	> button {
		background-color: ${({ $isActive }) => ($isActive ? token.gray75 : undefined)};
	}
`;
